import React, { useEffect, useState } from "react";
import "./LoadingIndicator.css";

const LoadingIndicator = ({ loading }) => {
  const [shouldRender, setShouldRender] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (loading) {
      setShouldRender(true); // 로딩이 시작되면 화면 유지
      setFadeOut(false); // 페이드아웃 초기화
    } else {
      setTimeout(() => setFadeOut(true), 2000); // 2초 후 페이드아웃 시작
      setTimeout(() => setShouldRender(false), 3000); // 3초 후 화면에서 제거
    }
  }, [loading]);

  if (!shouldRender) return null; // 완전히 사라지면 제거

  return (
    <div className={`loading-screen ${fadeOut ? "fade-out" : ""}`}>
      <p className="loading-text">Picklite</p>
    </div>
  );
};

export default LoadingIndicator;
